var _jsxFileName = "/codebuild/output/src2856833513/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/register/steps/RegisterMinorAccountInfo.tsx";
import React from 'react';
import { Text } from '@adc/parallax-component-library';
import { format, parseISO } from 'date-fns';
import { FormContainer, Input } from 'Components/utility';
import { getGenderDisplayText } from 'Utilities/dataHelpers';
import i18n from 'Utilities/i18n';
import { ContentContainer } from '../helpers';
function RegisterMinorAccountInfo({
  formikForm
}) {
  const {
    errors,
    values,
    touched,
    handleChange,
    handleBlur
  } = formikForm;
  return /*#__PURE__*/React.createElement(ContentContainer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Text, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 7
    }
  }, i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoFormMinor.primaryText')), /*#__PURE__*/React.createElement(FormContainer, {
    hasHiddenUserInput: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Input, {
    "aria-label": i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoFormMinor.formField.parentFirstName.label'),
    placeholder: i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoFormMinor.formField.parentFirstName.placeholder'),
    label: i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoFormMinor.formField.parentFirstName.label'),
    testID: "guardianFirstName",
    inputMode: "text",
    errorMessage: errors.guardianFirstName,
    isInvalid: errors.guardianFirstName && touched.guardianFirstName ? true : false,
    value: values.guardianFirstName,
    onChangeText: handleChange('guardianFirstName'),
    onBlur: handleBlur('guardianFirstName'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(Input, {
    "aria-label": i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoFormMinor.formField.parentLastName.label'),
    placeholder: i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoFormMinor.formField.parentLastName.placeholder'),
    label: i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoFormMinor.formField.parentLastName.label'),
    testID: "guardianLastName",
    inputMode: "text",
    errorMessage: errors.guardianLastName,
    isInvalid: errors.guardianLastName && touched.guardianLastName ? true : false,
    value: values.guardianLastName,
    onChangeText: handleChange('guardianLastName'),
    onBlur: handleBlur('guardianLastName'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(Text, {
    testID: "CreateAccountPersonalInfo.content.createAccountPersonalInfoFormMinor.secondaryText",
    fontWeight: "$bodySmall.strong",
    fontSize: "$bodySmall.strong",
    color: "$text.100",
    paddingTop: "$5",
    textTransform: "uppercase",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 65,
      columnNumber: 9
    }
  }, i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoFormMinor.secondaryText')), /*#__PURE__*/React.createElement(Input, {
    "aria-label": i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.firstName.label'),
    label: i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.firstName.label'),
    testID: "firstName",
    inputMode: "text",
    value: values.firstName,
    disabled: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 77,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(Input, {
    "aria-label": i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.lastName.label'),
    label: i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.lastName.label'),
    testID: "lastName",
    inputMode: "text",
    value: values.lastName,
    disabled: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 89,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(Input, {
    "aria-label": i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.dob.label'),
    label: i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.dob.label'),
    testID: "dateOfBirth",
    inputMode: "text",
    value: values.dateOfBirth ? format(parseISO(values.dateOfBirth), 'MM/dd/yyyy') : '',
    disabled: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 101,
      columnNumber: 9
    }
  }), values.country === 'FR' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Input, {
    testID: "gender",
    label: i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.gender.label'),
    placeholder: i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.gender.placeholder'),
    "aria-label": i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.gender.label'),
    value: getGenderDisplayText(values.gender),
    disabled: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 116,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement(Input, {
    testID: "birthCountry",
    label: i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.birthplace.label'),
    placeholder: i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.birthplace.placeholder'),
    "aria-label": i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.birthplace.label'),
    value: values.birthCountry ? i18n.t(`Global.microcopy.countries.${values.birthCountry.toUpperCase()}`) : '',
    disabled: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 130,
      columnNumber: 13
    }
  }), values.birthCountry === 'FR' && /*#__PURE__*/React.createElement(Input, {
    "aria-label": i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.birthplaceZipCode.label'),
    placeholder: i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.birthplaceZipCode.placeholder'),
    label: i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.birthplaceZipCode.label'),
    testID: "birthZipCode",
    value: values.birthZipCode,
    onChangeText: handleChange('birthZipCode'),
    onBlur: handleBlur('birthZipCode'),
    disabled: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 151,
      columnNumber: 15
    }
  }))));
}
export { RegisterMinorAccountInfo };